__turbopack_context__.v({
  "container": "linkingItem-module-scss-module__CLwNGG__container",
});
